import angular from 'angular';
import {
  alerts,
} from 'app/components/global';
import {
  loaderService,
  ssDialogService,
} from 'app/services';
import controller from './edit-settings-dialog.controller';
import template from './edit-settings-dialog.html';


class dialogService {
  getOptions($event, { settings }) {
    return {
      controller,
      controllerAs: 'demoSettingsDialogVM',
      locals: {
        settings
      },
      escapeToClose: false,
      clickOutsideToClose: false,
      targetEvent: $event,
      template,
    };
  }
}

export default angular.module('app.components.demo.settingsDialog', [
  alerts,
  loaderService,
  ssDialogService,
])
  .service('demoSettingsDialog', dialogService)
  .name;
